export default function DiagonalArrow(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path fill="none" d="m4 12 8-8" />
      <path d="M5.5 4H12v6.5" fill="none" />
    </svg>
  );
}
